module.exports = __webpack_public_path__ + "static/media/Logo-Semana-Pyme.b8dbcd21.png";